import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

// import { Page } from './css';
import {
  PaginationWrapper,
  PaginationContainer,
  PageButtons,
  NaviagationButtons,
  NaviagationButtonText,
  ActivePage
} from './css';

const getPages = (step, total) => {
  const pages = [];
  let page = 1;
  let index = 1;

  while (index <= total) {
    pages.push(page);
    page += 1;
    index += step;
  }

  return pages;
};

const Pagination = ({
  count,
  step,
  currentPage,
  setSrtPage,
  setOrderFulfillmentPage,
  setPage,
  url
}) => {
  const totalPages = 5;
  const pages = getPages(step, count);
  const getUrl = page => (url ? url.concat(`&page=${page}`) : `?page=${page}`);

  const handlePage = page => {
    // callbacks to set individual page state for each tab
    if (setSrtPage) {
      setSrtPage(page);
      localStorage.setItem('SrtPage', page);
    } else if (setOrderFulfillmentPage) {
      setOrderFulfillmentPage(page);
      localStorage.setItem('OrderFulfillmentPage', page);
    } else if (setPage) {
      setPage(page);
    }
  };

  return (
    <PaginationWrapper>
      <PaginationContainer>
        {currentPage > 1 && totalPages < pages.length && (
          <RouterLink to={getUrl(1)} style={{ textDecoration: 'none' }}>
            <NaviagationButtons onClick={() => handlePage(1)}>
              <NaviagationButtonText>«</NaviagationButtonText>
            </NaviagationButtons>
          </RouterLink>
        )}
        {(count > currentPage * step || currentPage > 1) &&
          pages.map(item => {
            const isVisible =
              pages.length <= totalPages ||
              (item < currentPage + 3 && item > currentPage - 3) ||
              ((currentPage === 1 || currentPage === 2) &&
                item <= totalPages) ||
              (currentPage === pages.length &&
                item >= pages.length - totalPages) ||
              (currentPage === pages.length - 1 &&
                item > pages.length - totalPages);
            const elem = (
              <PageButtons
                item={item}
                currentPage={currentPage}
                onClick={() => handlePage(item)}
              >
                {item}
              </PageButtons>
            );

            return (
              isVisible && (
                <Fragment key={`page${item}`}>
                  {item !== currentPage ? (
                    elem
                  ) : (
                    <ActivePage to={getUrl(item)}>
                      {elem}
                    </ActivePage>
                  )}
                </Fragment>
                // eslint-disable-next-line no-multiple-empty-lines
              )
            );
          })}
        {currentPage < pages.length && totalPages < pages.length && (
          <RouterLink to={getUrl(pages.length)} style={{ textDecoration: 'none' }}>
            <NaviagationButtons onClick={() => handlePage(pages.length)}>
              <NaviagationButtonText>»</NaviagationButtonText>
            </NaviagationButtons>
          </RouterLink>
        )}
      </PaginationContainer>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  count: PropTypes.number.isRequired,
  step: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setSrtPage: PropTypes.func,
  setOrderFulfillmentPage: PropTypes.func,
  setPage: PropTypes.func,
  url: PropTypes.string.isRequired
};

export default Pagination;
